/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'accepted': 'Akzeptiert',
    'cancel_quote': 'Angebot stornieren',
    'confirm_checked_quotes_delete_body': 'Möchtest du die ausgewählten Angebote wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_checked_quotes_delete_title': 'Ausgewählte Angebote löschen?',
    'confirm_commit_quote_body': 'Möchtest du das ausgewählte Angebot wirklich festschreiben? Das Angebot kann anschließend nicht mehr bearbeitet werden.',
    'confirm_commit_quote_title': 'Angebot festschreiben',
    'confirm_quote_cancel_body': 'Bist du sicher, dass du das Angebot stornieren möchtest?',
    'create_quote': 'Angebot erstellen',
    'expired': 'Verfallen',
    'mark_accepted': 'Als akzeptiert markieren',
    'quote': 'Angebot|Angebote',
    'quote_canceled': 'Angebot storniert',
    'quote_committed': 'Angebot wurde festgeschrieben',
    'quote_created': 'Angebot erstellt',
    'quote_created_by': 'Angebot erstellt von',
    'quote_deleted': 'Angebot erfolgreich gelöscht|Angebote erfolgreich gelöscht',
    'quote_draft_saved': 'Angebot wurde als Entwurf gespeichert',
    'quote_export_modal_body': 'Die Angebote können mit den untenstehenden Optionen gefiltert werden. Sollen alle Angebote exportiert werden,<br>klicke einfach auf "Exportieren".',
    'quote_export_modal_title': 'Angebote exportieren',
    'quote_filter_end_date': 'Angebotsdatum von',
    'quote_filter_start_date': 'Angebotsdatum bis',
    'quote_mail_default': 'Sehr geehrter Kunde / sehr geehrte Kundin,  \r\nIm Anhang finden Sie Ihr aktuelles Angebot im PDF-Format.  \r\nZum Ansehen und Ausdrucken des Angebotes wird ein PDF-Reader benötigt.  \r\n  \r\nMit freundlichen Grüßen  \r\nIhr {teamName} Team',
    'quote_meta': 'Angebotsinformationen',
    'quote_send_modal_successful_body': 'Das Angebot wurde an {address} versendet und sollte bald ankommen.',
    'quote_send_modal_title': 'Angebot senden',
    'quote_status': 'Angebotsstatus',
    'quote_text_template_deleted': 'Textvorlage wurde gelöscht',
    'quotes_empty': 'Keine Angebote vorhanden',
    'valid_until': 'Gültig bis'
  },

  /* english */
  en: {
    'accepted': 'Accepted',
    'cancel_quote': 'Cancel quote',
    'confirm_checked_quotes_delete_body': 'Do you really want to delete the selected quotes? This can not be undone!',
    'confirm_checked_quotes_delete_title': 'Delete selected quotes?',
    'confirm_commit_quote_body': 'Do you really want to commit this quote? You can no longer edit quotes once they are committed.',
    'confirm_commit_quote_title': 'Commit quote',
    'confirm_quote_cancel_body': 'Are you sure you want to cancel the quote?',
    'create_quote': 'Create quote',
    'expired': 'Expired',
    'mark_accepted': 'Mark as accepted',
    'quote': 'Quote|Quotes',
    'quote_canceled': 'Quote canceled',
    'quote_committed': 'Quote was committed',
    'quote_created': 'Quote created',
    'quote_created_by': 'Quote created by',
    'quote_deleted': 'Quote deleted|Quotes deleted',
    'quote_draft_saved': 'Quote is saved as a draft',
    'quote_export_modal_body': 'You can filter the export if you wish. If you like to export all quotes,<br>just click "Export".',
    'quote_export_modal_title': 'Export Quotes',
    'quote_filter_end_date': 'Quote date to',
    'quote_filter_start_date': 'Quote date from',
    'quote_mail_default': 'Dear customer,  \r\nattached you find your recent quote as PDF.  \r\nTo view and print your invoice you need a PDF-Reader.  \r\n  \r\nSincerely yours  \r\n{teamName} team.',
    'quote_meta': 'Quote details',
    'quote_send_modal_successful_body': 'The quote has been sent to {address} and should arrive soon.',
    'quote_send_modal_title': 'Send Quote',
    'quote_status': 'Quote status',
    'quote_text_template_deleted': 'Text template has been deleted',
    'quotes_empty': 'No quotes',
    'valid_until': 'Valid until'
  }
}
